//firebase config data

export default {
  apiKey: 'AIzaSyCOIbdl1dblas3becJEm8OCGR__Ezv8RzM',
  authDomain: 'levels-production.firebaseapp.com',
  databaseURL: 'https://levels-production.firebaseio.com',
  projectId: 'levels-production',
  storageBucket: 'levels-production.appspot.com',
  messagingSenderId: '414329408783'
}
